<ui-card [class.loading]="isLoading" *ngIf="chartData?.labels?.length > 0">
    <app-segment-header title="applicant-tracker.sourceReporting">
        <div class="buttons margin-right-2">
            <ui-button type="outline" style="float: right" [matMenu]="exportMenu">
                {{ 'applicant-tracker.export' | appTranslate }} <mat-icon svgIcon="chevronDown"></mat-icon>
            </ui-button>
            <mat-menu #exportMenu="matMenu">
                <button mat-menu-item (click)="onExport('csv')">
                    {{ 'applicant-tracker.export-as-csv' | appTranslate }}
                </button>
                <button mat-menu-item (click)="onExport('xlxs')">
                    {{ 'applicant-tracker.export-as-xlsx' | appTranslate }}
                </button>
            </mat-menu>
        </div>
    </app-segment-header>

    <p [innerHTML]="'applicant-tracker.youMightFindSomeSourcesAsUnknown' | appTranslate"></p>

    <app-chart-data-table
        [reportingServiceData]="chartData"
        label="{{ 'applicant-tracker.source' | appTranslate }}"
    ></app-chart-data-table>
</ui-card>
